import type { ID } from '@octopus-do/octopus-project-core'
import type React from 'react'

import css from '../../../../../ArtBoard/Blocks/Blocks.module.scss'
import { Block } from './Block'

type BlocksListType = {
  ids: string[]
  blockId?: ID
}

export const BlocksList: React.FC<BlocksListType> = ({ ids, blockId }) => {
  if (!ids) {
    return null
  }

  return (
    <div className={css.container}>
      {ids.map((id, index) => {
        return (
          <div className="block" key={index}>
            <div className={css.pseudoDropzoneWrapper}>
              <Block
                id={id}
                blockId={blockId}
                isLast={ids.length - 1 === index}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
